import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { commonPageFieldList, commonPageFieldListSuccess, getItemList } from "../../../store/actions";
import CommonListPage from "../../../components/Common/CommonMasterListPage";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url";
import { PageLoadingSpinner } from "../../../components/Common/CommonButton";
import RateMaster from "./RateMaster";
import { deleteRateListId, deleteRateListId_Success, getRateList, saveRateMasterSuccess } from "../../../store/Administrator/RateMasterRedux/action";
import { editEmployeeeId } from "../../../store/Administrator/EmployeeRedux/action";
import { useState } from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";
import { C_DatePicker, C_Select } from "../../../CustomValidateForm";
import * as _cfunc from "../../../components/Common/CommonFunction";


const RateList = () => {

    const dispatch = useDispatch();

    const currentDate = _cfunc.date_ymd_func();

    const [fromDate, setFromDate] = useState(currentDate);
    const [toDate, setToDate] = useState(currentDate);
    const [item, setItem] = useState("");


    const reducers = useSelector(
        (state) => ({
            listBtnLoading: state.RateMasterReducer.listBtnLoading,
            GoBtnlistloading: state.RateMasterReducer.GoBtnlistloading,
            tableList: state.RateMasterReducer.RateListData,
            updateMsg: state.EmployeesReducer.updateMessage,
            editData: state.EmployeesReducer.editData,
            deleteMsg: state.RateMasterReducer.deleteMsg,
            postMsg: state.RateMasterReducer.postMsg,

            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList,
            ItemList: state.ItemMastersReducer.ItemList,
        })
    );

    const action = {
         getList: getRateList,
        editId: editEmployeeeId,
        deleteId: deleteRateListId,
        deleteSucc: deleteRateListId_Success,
        postSucc: saveRateMasterSuccess
    }

    //  This UseEffect => Featch Modules List data  First Rendering
    useEffect(() => {
        const page_Id = pageId.RATE_LIST
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(page_Id))
        //   dispatch(getRateList());
        dispatch(getItemList());

     
    }, []);

    const Items = reducers.ItemList.map((Data) => ({
        value: Data.id,
        label: Data.Name
    }));

    const { pageField, GoBtnlistloading } = reducers

    const handleGoClick = () => {

       
    
        const body = {
           
            FromDate: fromDate,
            ToDate: toDate,
            ItemId: item.value
        };
    
        dispatch(getRateList(body));   
    };

    return (
        <React.Fragment>

            <PageLoadingSpinner isLoading={(GoBtnlistloading || !pageField)} />

            {
                (pageField) &&
                <>
                    {/*  FILTER UI */}
                    <div className="px-2 c_card_filter text-black">
                        <Row>

                            {/* From Date */}
                            <Col sm={3}>
                                <FormGroup className="row mt-2">
                                    <Label className="col-sm-4 p-2">From Date</Label>
                                    <Col sm="7">
                                        <C_DatePicker
                                            value={fromDate}
                                            onChange={(e, date) => setFromDate(date)}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>

                            {/* To Date */}
                            <Col sm={3}>
                                <FormGroup className="row mt-2">
                                    <Label className="col-sm-4 p-2">To Date</Label>
                                    <Col sm="7">
                                        <C_DatePicker
                                            value={toDate}
                                            onChange={(e, date) => setToDate(date)}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>

                            {/* Item Dropdown */}
                            <Col sm={3}>
                                <FormGroup className="row mt-2">
                                    <Label className="col-sm-4 p-2">Item</Label>
                                    <Col sm="8">
                                        <C_Select
                                            value={item}
                                            options={Items}
                                            onChange={(e) => setItem(e)}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>

                            {/* Go Button */}
                            <Col sm={3} className="d-flex justify-content-end">
                                <button
                                    className="btn btn-success m-2"
                                     onClick={handleGoClick}
                                     disabled={GoBtnlistloading}
                                >
                                    Show
                                </button>
                            </Col>

                        </Row>
                    </div>

                    {/* ✅ LIST PAGE */}
                    <CommonListPage
                        action={action}
                        reducers={reducers}
                        MasterModal={RateMaster}
                        masterPath={url.RATE_MASTER}
                        ButtonMsgLable={"Rate"}
                        deleteName={"EffectiveDate"}
                    />
                </>
            }

        </React.Fragment>
    )
}

export default RateList
